import { createRoutine } from "redux-saga-routines";

export const setError = createRoutine('SET_ERROR');